export enum RepairType {
    API_RESPONSE_SUCCESS = '@@repair/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@repair/API_RESPONSE_ERROR',
    REPAIR_RECE = '@@repair/REPAIR_RECE',
    UPD_REPAIR_RECE = '@@repair/UPD_REPAIR_RECE',
    REPAIR_SEND = '@@repair/REPAIR_SEND',
    UPD_REPAIR_SEND = '@@repair/UPD_REPAIR_SEND',
    REPAIR_RETURN = '@@repair/REPAIR_RETURN',
    UPD_REPAIR_RETURN = '@@repair/UPD_REPAIR_RETURN',
    REPAIR_HANDOVER = '@@repair/REPAIR_HANDOVER',
    UPD_REPAIR_HANDOVER = '@@repair/UPD_REPAIR_HANDOVER',
    RESET = '@@repair/RESET',
}